import React from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ArrowUpRight } from "lucide-react";

export default function FileCaseAuthDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="file-case-auth-dialog"
        className="bg-sand text-ink border-0 sm:max-w-[480px] p-0 [&>button]:text-ink/60"
        style={{ borderRadius: 4 }}
      >
        <div className="p-8 sm:p-10 text-center">
          <div className="font-mono text-[11px] tracking-[0.16em] uppercase text-clay">File a case</div>
          <DialogHeader className="mt-3">
            <DialogTitle className="font-display text-[26px] sm:text-[30px] text-ink text-center" style={{ fontWeight: 400, lineHeight: 1.15 }}>
              Already have an account?
            </DialogTitle>
          </DialogHeader>
          <p className="mt-3 text-ink/65 text-[13.5px]">
            Sign in to file a new dispute, upload evidence and track hearings from your dashboard.
          </p>

          <Link
            to="/login"
            onClick={() => onOpenChange(false)}
            data-testid="file-case-signin"
            className="mt-7 group inline-flex w-full items-center justify-center gap-2 px-6 py-4 text-[15px] font-medium bg-clay text-sand hover:bg-[hsl(17_64%_42%)] transition-colors"
            style={{ borderRadius: 3 }}
          >
            Sign in
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>

          <div className="mt-6 flex items-center gap-3 text-[11px] font-mono tracking-[0.14em] uppercase text-ink/45">
            <span className="flex-1 h-px bg-ink/15" />
            <span>New here?</span>
            <span className="flex-1 h-px bg-ink/15" />
          </div>

          <Link
            to="/register"
            onClick={() => onOpenChange(false)}
            data-testid="file-case-register"
            className="mt-4 inline-flex w-full items-center justify-center gap-2 px-6 py-3 text-[14px] font-medium border border-ink/25 text-ink hover:border-ink transition-colors"
            style={{ borderRadius: 3 }}
          >
            Create an account
          </Link>
        </div>
      </DialogContent>
    </Dialog>
  );
}
